<template lang="pug">
el-dialog(v-dialog-drag, width="550px", :title="title", :visible.sync="visible", @closed="onclosed", :close-on-click-modal="false")
  table(border)
    tr
      th.from {{ fromLabel }}
      th.link
      th.to {{ toLabel }}
      th.op
        el-button(v-if="!readonly", size="mini", icon="el-icon-plus", type="text", @click="add")
    tr(v-for="row in list", :key="row.id")
      td
        template(v-if="isInput")
          el-input(v-model="row.from", size="mini", placeholder="请输入字段名称")
        template(v-else)
          el-select.width-fill(v-model="row.from", :disabled="readonly", filterable, size="mini")
            el-option(v-for="item in from", :key="item.columnName", :label="item | label", :value="item.columnName")
      td.link 填充至
      td
        el-select.width-fill(v-model="row.to", :disabled="readonly", filterable, size="mini")
          el-option(v-for="item in toListFormat", :key="item.columnName", :label="item | label", :value="item.name")
      td.op
        el-button(v-if="!readonly", size="mini", icon="el-icon-minus", type="text", @click="deleteItem(row)")
  .empty(v-if="!list.length") 暂无填充项
  template(#footer)
    el-button(size="small", @click="close()") 关闭
    el-button(v-if="!readonly", size="small", type="primary", @click="submit()") 确定
</template>
<script>
import service from "@/CommonDP/service/metadata-service.js";
import { asyncMixin } from "@/CommonDP/commons/asyncCom";
const cache = {};
export default {
  filters: {
    label(item) {
      return `${item.columnDisplayName}(${item.columnName})`;
    }
  },
  mixins: [asyncMixin],
  props: {
    title: { default: "数据填充", type: String },
    fromId: { default: "", type: String },
    toId: { default: "", type: String },
    subFormId: { default: "", type: String },
    readonly: { default: false, type: Boolean }
  },
  data() {
    return { visible: true, list: [], from: [], to: [], fromLabel: "填充项", toLabel: "被填充项（当前表单）" };
  },
  computed: {
    isInput() {
      return !this.fromId;
    },
    toListFormat() {
      const { toId, to, subFormId } = this;
      const prefix = subFormId ? `${toId}_${subFormId}-` : "";
      return to.map((item) => ({
        ...item,
        name: `${prefix}${item.columnName}`
      }));
    }
  },
  async created() {
    this.open();
  },
  methods: {
    async open() {
      const [from, to] = await Promise.all([this.getFrom(this.fromId), this.getFrom(this.toId)]);
      this.from = from;
      this.to = to;
      this.visible = true;
    },
    async deleteItem(row) {
      const id = row?.id;
      if (id) {
        await this.$confirm("确定删除", "警告");
        this.list = this.list.filter((r) => r.id !== id);
      }
    },
    close() {
      this.visible = false;
    },
    onclosed() {
      this.$emit("reject", this.list);
    },
    validate() {
      for (const { to, from } of this.list) {
        if (!to || !from) {
          const msg = "不能选择空";
          this.$message.warning(msg);
          throw new Error(msg);
        }
      }
    },
    async submit() {
      await this.validate();
      this.$emit("resolve", this.list);
      this.visible = false;
    },
    add() {
      this.list.push({ id: Date.now(), from: "", to: "" });
    },
    async getFrom(tableId) {
      if (!tableId) return [];
      const oldFn = cache[tableId];
      const promise = oldFn || service.columnList(tableId);
      if (!oldFn) cache[tableId] = promise;
      const { data } = await promise;
      return data;
    }
  }
};
</script>
<style lang="scss" src="./metaFix.scss" scoped></style>
